var listItems = document.querySelectorAll('.image-with-text__content li.image-with-text__list');
var images = document.querySelectorAll('.image-with-text__media-item .image-with-text__teaser-image');

listItems.forEach((item, index) => {
    item.addEventListener('mouseover', () => {
        const target = item.getAttribute('data-title');
        images.forEach((image) => {
            if(image.getAttribute('data-target') === target) {
                image.classList.add('teaser-hover-active');
            }
        });
    });

    item.addEventListener('mouseout', () => {
        const target = item.getAttribute('data-title');
        images.forEach((image) => {
            if(image.getAttribute('data-target') === target) {
                image.classList.remove('teaser-hover-active');
            }
        });
    });
});